import { loggedIn } from '../cloud/api.js';
import { mainPlace, placesFor } from '../model.js';
import { rateFields, sameAs } from '../place-ui.js';
import { addonsCard, availCard, bindAddons, bindAvail } from '../cloud/addons.js';
import { accountPane, bindAccountPane } from '../cloud/account.js';
import { planCard } from '../cloud/plan.js';
import { settingsFeedCard, settingsRemindersCard } from '../notify/reminders.js';
import { t } from '../i18n/index.js';
import { S, persist } from '../state.js';
import { applyTheme, updateLangButtons } from '../theme.js';
import { IC, RT, esc, nav, render } from '../ui.js';
import { FLAGS, LANG_NAMES } from '../flags.js';
import { isTutor } from '../team/team.js';
import { bindTeamPane, teamPane } from './team.js';
/* settings key of each place's default rate: the main place is the plain default rate */
const setKey=p=>p===mainPlace(null)?'defRate':(p==='online'?'rateOnline':'rateSite');
/* Settings, the way Linear or Notion do it: a short menu of sections and one section at a time.
   Desktop: menu left, section right. Phone: the menu is a list, a section opens on tap (with back). */
const I={
  profile:'<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg>',
  billing:'<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18M7 15h4"/></svg>',
  teaching:'<svg viewBox="0 0 24 24"><path d="M3 8l9-4 9 4-9 4-9-4z"/><path d="M7 10v4.5c0 1.7 2.2 3 5 3s5-1.3 5-3V10"/></svg>',
  reminders:'<svg viewBox="0 0 24 24"><path d="M6 16v-5a6 6 0 1 1 12 0v5l2 2H4l2-2z"/><path d="M10 20.5a2 2 0 0 0 4 0"/></svg>',
  calendar:'<svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>',
  appearance:'<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 0 0 17z" fill="currentColor" stroke="none"/></svg>',
  plan:'<svg viewBox="0 0 24 24"><path d="M13 2.5 4.5 13.5h6.5l-1 8 8.5-11h-6.5z"/></svg>',
  account:'<svg viewBox="0 0 24 24"><path d="M12 3l7.5 3v5.5c0 4.6-3.2 7.9-7.5 9.5-4.3-1.6-7.5-4.9-7.5-9.5V6z"/></svg>',
  team:'<svg viewBox="0 0 24 24"><circle cx="9" cy="8" r="3.5"/><path d="M3 20c.8-3.5 3.2-5.5 6-5.5s5.2 2 6 5.5"/><path d="M16 4.5a3.5 3.5 0 0 1 0 7M21 20c-.4-2.4-1.6-4.1-3.4-5"/></svg>',
};
const ALL=['profile','billing','teaching','team','reminders','calendar','appearance','plan','account'];
const SECS_FOR=()=>isTutor()?['team','reminders','calendar','appearance','account']:ALL;
const isPhone=()=>matchMedia('(max-width:760px)').matches;

/** Open settings, optionally straight at one section (used by the profile menu, onboarding, cards). */
export function openSettings(sec){
  if(sec&&!SECS_FOR().includes(sec))sec=null;RT.setSec=sec||null;if(RT.v==='settings')render();else nav('settings')}

function subjectChips(){
  const mine=S.settings.subjects||[];
  const all=[...new Set([...mine,...t('wl.subjectList').split('|')])];
  return all.map(x=>`<button type="button" class="chip" aria-pressed="${mine.includes(x)}" data-subj="${esc(x)}">${esc(x)}</button>`).join('');
}

export function vSettings(){
  const st=S.settings;const SECS=SECS_FOR();
  const cur=RT.setSec&&SECS.includes(RT.setSec)?RT.setSec:(isPhone()?null:SECS[0]);
  RT.setSec=cur;
  const inp=(id,label,val,type,ph)=>`<div class="field"><label for="${id}">${label}</label><input class="input" id="${id}" type="${type||'text'}" value="${esc(val??'')}" placeholder="${esc(ph||'')}"></div>`;
  const pane=(k,html)=>!SECS.includes(k)?'':`<section class="setpane${cur===k?' on':''}" data-pane="${k}" aria-labelledby="sh-${k}">
    <div class="panehead"><button class="iconbtn paneback" data-setback aria-label="${esc(t('c.back'))}">${IC.left}</button>
    <div><h2 id="sh-${k}">${t('set.s.'+k)}</h2><p>${t('set.s.'+k+'.d')}</p></div></div>${html}</section>`;
  return `<div class="viewhead"><div><h1>${t('set.title')}</h1><span class="savedflag" id="savedflag" aria-live="polite">${IC.check} ${t('c.saved')}</span></div></div>
  <div class="setlayout${cur?' open':''}">
    <nav class="setnav" aria-label="${esc(t('set.title'))}">${SECS.map(k=>`<button class="setnavbtn${cur===k?' on':''}" data-sec="${k}" aria-current="${cur===k?'page':'false'}"><span class="sic">${I[k]}</span><span class="grow"><b>${t('set.s.'+k)}</b><small>${t('set.s.'+k+'.d')}</small></span><span class="chev">${IC.right}</span></button>`).join('')}</nav>
    <div class="setpanes">
      ${pane('profile',`<div class="card">
        ${inp('se-teacher',t('set.you'),st.teacher)}
        ${inp('se-biz',t('set.biz'),st.biz)}
        <div class="field"><label for="se-addr">${t('set.addr')}</label><textarea class="textarea" id="se-addr" style="min-height:76px">${esc(st.addr)}</textarea></div>
      </div>`)}
      ${pane('billing',`<div class="card mb"><h3 class="cardsub">${t('set.payTo')}</h3>
        <div class="formrow">${inp('se-iban',t('set.iban'),st.iban)}${inp('se-bank',t('set.bank'),st.bank)}</div>
        ${inp('se-paypal',t('set.paypal'),st.paypal)}
        ${inp('se-tax',t('set.tax'),st.taxId)}
      </div>
      <div class="card"><h3 class="cardsub">${t('set.invoicing')}</h3>
        <div class="formrow3">${inp('se-prefix',t('set.prefix'),st.invPrefix)}${inp('se-next',t('set.nextNo'),st.invNext,'number')}${inp('se-due',t('set.due'),st.dueDays,'number')}</div>
        <label class="check mb8"><input type="checkbox" id="se-klein" ${st.kleinOn?'checked':''}> ${t('set.kleinOn')}</label>
        <label class="check"><input type="checkbox" id="se-vat" ${st.vatOn?'checked':''}> ${t('set.vatOn')}</label>
        <div class="formrow mt8" id="vatpwrap" style="${st.vatOn?'':'display:none'}"><div class="field"><label for="se-vatp">${t('set.vatP')}</label><input class="input" type="number" id="se-vatp" value="${st.vatP}"></div><div></div></div>
      </div>`)}
      ${pane('teaching',`<div class="card mb"><h3 class="cardsub">${t('set.mySubjects')}</h3>
        <p class="hint mb8">${t('set.mySubjectsHint')}</p>
        <div class="chips" id="se-subjects">${subjectChips()}</div>
        <div class="row mt8 subjadd"><input class="input" id="se-subjadd" placeholder="${esc(t('wl.other'))}"><button class="btn small" data-subjadd>${IC.plus} ${t('c.add')}</button></div>
      </div>
      <div class="card"><h3 class="cardsub">${t('set.defaults')}</h3>
        <p class="ratehead">${t('place.rates',{cur:st.currency||'EUR'})}</p>
        ${rateFields('se-r',st,null,setKey,p=>p===mainPlace(null)?'30':sameAs(null))}
        <p class="hint mb">${t('place.ratesHint')}</p>
        <div class="formrow">${inp('se-dur',t('set.defDur'),st.defDur,'number')}
          <div class="field"><label for="se-curr">${t('set.curr')}</label><select class="select" id="se-curr">${['EUR','CHF','USD','GBP'].map(c=>'<option'+(c===st.currency?' selected':'')+'>'+c+'</option>').join('')}</select></div></div>
        ${inp('se-late',t('set.lateCancel'),st.lateCancelH??24,'number')}
        <p class="hint">${t('set.lateCancelHint')}</p>
      </div>
      ${loggedIn()?availCard():''}`)}
      ${pane('reminders',settingsRemindersCard())}
      ${pane('calendar',settingsFeedCard())}
      ${pane('appearance',`<div class="card">
        <div class="field"><label>${t('set.uiLang')}</label><div class="wl-langs">${['de','en','fr'].map(l=>`<button type="button" class="wl-lang" data-setlang="${l}" aria-pressed="${st.lang===l}"><span class="flag">${FLAGS[l]}</span>${LANG_NAMES[l]}</button>`).join('')}</div></div>
        <div class="field"><label>${t('set.theme')}</label><div class="seg" id="se-theme">${['light','dark','auto'].map(x=>`<button type="button" data-th="${x}" class="${st.theme===x?'on':''}">${t('set.t.'+x)}</button>`).join('')}</div></div>
      </div>`)}
      ${pane('plan',planCard()+addonsCard())}
      ${pane('account',accountPane())}
      ${SECS.includes('team')?pane('team',teamPane()):''}
    </div>
  </div>`;
}

export function bindSettings(m){
  const st=S.settings;const q=x=>m.querySelector(x);
  bindAddons(m);bindAvail(m);
  const flash=()=>{const f=document.getElementById('savedflag');if(!f)return;f.classList.add('on');clearTimeout(f._t);f._t=setTimeout(()=>f.classList.remove('on'),1800)};
  const lay=q('.setlayout');
  const show=k=>{
    RT.setSec=k;lay.classList.toggle('open',!!k);
    m.querySelectorAll('.setnavbtn').forEach(b=>{const on=b.dataset.sec===k;b.classList.toggle('on',on);b.setAttribute('aria-current',on?'page':'false')});
    m.querySelectorAll('.setpane').forEach(p=>p.classList.toggle('on',p.dataset.pane===k));
    if(isPhone())window.scrollTo({top:0});
  };
  m.querySelectorAll('.setnavbtn').forEach(b=>b.onclick=()=>show(b.dataset.sec));
  m.querySelectorAll('[data-setback]').forEach(b=>b.onclick=()=>show(null));
  const on=(id,fn)=>{const el=q('#'+id);if(el)el.onchange=e=>{fn(e.target);persist();flash()}};
  const map={'se-teacher':'teacher','se-biz':'biz','se-addr':'addr','se-tax':'taxId','se-iban':'iban','se-bank':'bank','se-paypal':'paypal','se-prefix':'invPrefix'};
  for(const id in map)on(id,el=>{st[map[id]]=el.value});
  for(const p of placesFor(null))on('se-r-'+p,el=>{const k=setKey(p),v=parseFloat(el.value);
    if(k==='defRate')st.defRate=v>0?v:30;else if(el.value!==''&&isFinite(v)&&v>=0)st[k]=v;else delete st[k]});
  on('se-dur',el=>{st.defDur=+el.value||60});
  on('se-next',el=>{st.invNext=+el.value||1});
  on('se-due',el=>{st.dueDays=+el.value||14});
  on('se-vatp',el=>{st.vatP=+el.value||19});
  on('se-late',el=>{st.lateCancelH=Math.max(0,+el.value||0)});
  on('se-curr',el=>{st.currency=el.value;setTimeout(render,0)});
  on('se-vat',el=>{st.vatOn=el.checked;if(st.vatOn){st.kleinOn=false;q('#se-klein').checked=false}q('#vatpwrap').style.display=st.vatOn?'':'none'});
  on('se-klein',el=>{st.kleinOn=el.checked;if(st.kleinOn){st.vatOn=false;q('#se-vat').checked=false;q('#vatpwrap').style.display='none'}});
  m.querySelectorAll('[data-setlang]').forEach(b=>b.onclick=()=>{st.lang=b.dataset.setlang;persist();updateLangButtons();render()});
  m.querySelectorAll('#se-theme [data-th]').forEach(b=>b.onclick=()=>{st.theme=b.dataset.th;persist();applyTheme();m.querySelectorAll('#se-theme [data-th]').forEach(x=>x.classList.toggle('on',x===b));flash()});
  // subjects the teacher teaches (suggested for new students)
  const saveSubj=()=>{st.subjects=[...m.querySelectorAll('#se-subjects .chip[aria-pressed=true]')].map(c=>c.dataset.subj);persist();flash()};
  m.querySelectorAll('#se-subjects .chip').forEach(c=>c.onclick=()=>{c.setAttribute('aria-pressed',c.getAttribute('aria-pressed')==='true'?'false':'true');saveSubj()});
  const add=()=>{const i=q('#se-subjadd');const v=(i.value||'').trim();if(!v)return;st.subjects=[...new Set([...(st.subjects||[]),v])];persist();render()};
  const ab=q('[data-subjadd]');if(ab)ab.onclick=add;
  const ai=q('#se-subjadd');if(ai)ai.onkeydown=e=>{if(e.key==='Enter'){e.preventDefault();add()}};
  m.addEventListener('change',flash);
  bindAccountPane(m);
  bindTeamPane(m);
}

/* ================= global bindings ================= */
